import { lazy, Suspense } from "react";
import { AuthSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/AuthenticationPages/forgotPassword"));

const ForgotPassword = () => {
  return (
      <Suspense fallback={<AuthSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default ForgotPassword;

